module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"link":"View original"}}')
  delete Component.options._Ctor
}
